import { useEffect, useRef } from 'react';

// Relative imports
import {
  getPersistedProspectEmail,
  initHubSpotTrustCenterTracking,
  trackTrustCenterEvent,
  trustCenterViewedEventName,
  trustCenterViewedProperties,
} from './hubspotTracking.js';

/**
 * Initialize HubSpot once on the public Trust Center shell.
 * Optionally re-fires trust_center_viewed with companyName once company data loads
 * for an identified prospect (workflow re-enrollment must be enabled in HubSpot).
 *
 * @param {{ publicId?: string | null, companyName?: string | null }} params
 */
export function useHubSpotTrustCenterTracking({ publicId = null, companyName = null } = {}) {
  const booted = useRef(false);
  const portalIdRef = useRef('');
  const identifiedRef = useRef(false);
  const enrichedCompanyRef = useRef(null);

  useEffect(() => {
    if (booted.current) return;
    if (!publicId) return;

    const result = initHubSpotTrustCenterTracking({ publicId });
    portalIdRef.current = result.portalId || '';
    identifiedRef.current = Boolean(result.identified) || Boolean(getPersistedProspectEmail());
    booted.current = true;
  }, [publicId]);

  useEffect(() => {
    if (!booted.current) return;
    if (!portalIdRef.current) return;
    if (!identifiedRef.current) return;
    if (!publicId || !companyName) return;
    if (enrichedCompanyRef.current === companyName) return;

    trackTrustCenterEvent(
      trustCenterViewedEventName(portalIdRef.current),
      trustCenterViewedProperties({ publicId, companyName })
    );
    enrichedCompanyRef.current = companyName;
  }, [publicId, companyName]);
}
